import { Divider, Stack, styled, useTheme } from '@mui/material';
import React from 'react';
import { FormatCurrency } from '../../utils/numbers';
import WalletAmount from './WalletAmount';
import { ErrorBoundaryXcala } from '../ErrorBoundaryXcala';

const ContentFloating = styled(Stack)(({ theme }) => ({
  position: 'relative',
  marginTop: '40px',
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px 24px',
  boxSizing: 'border-box',
  overflow: 'hidden',
  height: '89px',
  width: '100%',
  gap: '8px',
  animation: 'ease-in-out',
}));

const CoinFloating = ({ balanceData, marginTop, loadingBalance, errorBalance }) => {
  const theme = useTheme();
  return (
    <>
      <ContentFloating marginTop={marginTop} maxWidth={{ xs: '100%', sm: '100%' }}>
        <ErrorBoundaryXcala padding={0} onlyImage imageWidth='50px' imageHeight='50px'>
          <WalletAmount
            coinValue={FormatCurrency(balanceData?.balance)}
            direction={'start'}
            title='Caja Disponible'
            textAlign={'left'}
            loadingBalance={loadingBalance}
            errorBalance={errorBalance}
          />
          <Divider orientation='vertical' color={theme.palette.primary.darkBlue} />
          <WalletAmount
            direction='end'
            title='Dinero en Tránsito'
            coinValue={FormatCurrency(balanceData?.transitAmount)}
            textAlign={'right'}
            loadingBalance={loadingBalance}
            errorBalance={errorBalance}
          />
        </ErrorBoundaryXcala>
      </ContentFloating>
    </>
  );
};

export default CoinFloating;
